// extracted by mini-css-extract-plugin
module.exports = {"runMassPredictionModal":"styles_runMassPredictionModal__3GEHZ","filter":"styles_filter__1qu26","tables":"styles_tables__3dDad","tableRow":"styles_tableRow__1uUCI"};